module.exports = __webpack_public_path__ + "images/mmm-faq-03-desktop.png";